import React from "react";
import { useDashTheme } from "../hooks/useDashTheme";

// One-line count strip: colored dot, number, label, hairline dividers.
// Replaces the four-to-six big stat cards that used to sit above every list and
// push the actual data below the fold.
//
// items: [{ label, value, accent }]
export function StatStrip({ items }) {
  const t = useDashTheme();
  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: t.s[4] }}>
      {items.filter(Boolean).map((it, i) => (
        <React.Fragment key={it.label}>
          {i > 0 && <span style={{ width: 1, height: 16, background: t.c.border, margin: `0 ${t.s[4]}px` }} />}
          <span style={{ display: "inline-flex", alignItems: "baseline", gap: 7 }}>
            <span style={{ width: 6, height: 6, borderRadius: 99, background: it.accent, alignSelf: "center" }} />
            <span style={{ fontSize: t.font.size.lg, fontWeight: 600, color: t.c.text, letterSpacing: "-0.01em", fontVariantNumeric: "tabular-nums" }}>{it.value}</span>
            <span style={{ fontSize: t.font.size.sm, color: t.c.textTertiary }}>{it.label}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
